import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/reward.svg";
var RewardSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  RewardSolid_default as default
};
